// 言語一覧
const LANG_TYPE = {
  JA: 'ja', // 日本語
  EN: 'en', // 英語
  ZH: 'zh', // 中国語
} as const
type LANG_TYPE = typeof LANG_TYPE[keyof typeof LANG_TYPE]

// 言語表示情報
type LangData = {
  // 画面表示ラベルのi18nリソースキー
  labelKey: string
  // 画面value値
  value: string
  // input部品のID
  id: string
}

// 言語設定一覧
const LangList: Array<LangData> = [
  {
    labelKey: 'header.lang.locale.ja',
    value: LANG_TYPE.JA,
    id: 'langualgeJa',
  },
  {
    labelKey: 'header.lang.locale.en',
    value: LANG_TYPE.EN,
    id: 'langualgeEn',
  },
  {
    labelKey: 'header.lang.locale.zh',
    value: LANG_TYPE.ZH,
    id: 'langualgeZh',
  },
]

// 言語のデフォルト
const defaultLang = LANG_TYPE.JA

// 言語設定一覧
const localStorageKey = 'language'

/**
 * localStorageに設定している言語を取得する
 * @returns 取得した言語
 */
const getlocalStorageLang = () => {
  // localStorageから取得できない場合はjaを返す
  const data = localStorage.getItem(localStorageKey)
  if (data === null) {
    return defaultLang
  }
  // 取得した指定言語を返す。想定外のデータの場合はデフォルト言語を返す
  switch (data) {
    case LANG_TYPE.JA: {
      return data
    }
    case LANG_TYPE.EN: {
      return data
    }
    case LANG_TYPE.ZH: {
      return data
    }
    default: {
      return defaultLang
    }
  }
}

export {
  LANG_TYPE, //
  LangData,
  LangList, //
  localStorageKey,
  defaultLang,
  getlocalStorageLang,
}
